import React from 'react';
import ErrorAlert from './ErrorAlert';
import SuccessAlert from './SuccessAlert';

interface ResponseStatusFeedbackProps {
    isSuccess: boolean;
    successMessage: string;
    isError: boolean;
    errorMessage: string;
    time?: number;
}

const ResponseStatusFeedback: React.FC<ResponseStatusFeedbackProps> = ({
    isSuccess = false,
    isError = false,
    successMessage,
    errorMessage,
    time,
}) => {
    if (isSuccess) return <SuccessAlert message={successMessage} time={time} />;

    if (isError) return <ErrorAlert message={errorMessage} time={time} error="" />;

    return null;
};

export default ResponseStatusFeedback;
